// Clinical/veterinary standard: 1 kg = 2.2 lbs (divide by 2.2)
// This matches what practitioners use for dosing calculations
const LBS_TO_KG_DIVISOR = 2.2;

function normalizeUnit(unit: unknown): string {
  if (typeof unit !== 'string') {
    return '';
  }
  return unit.trim().toLowerCase();
}

function normalizeRawValue(value: unknown): string {
  if (value === null || value === undefined) {
    return '';
  }

  if (typeof value === 'number') {
    return Number.isFinite(value) ? String(value) : '';
  }

  return String(value).trim();
}

export function isNumericWeightValue(value: unknown): boolean {
  const raw = normalizeRawValue(value);
  if (!raw) {
    return false;
  }

  const parsed = Number(raw);
  return Number.isFinite(parsed);
}

export function canShowLbsToKgConversion(value: unknown, unit: unknown): boolean {
  return normalizeUnit(unit) === 'lbs' && isNumericWeightValue(value);
}

export function formatWeightDisplay(
  value: unknown,
  unit: unknown,
  options: { decimals?: number; defaultUnit?: string; emptyFallback?: string } = {}
): string {
  const decimals = options.decimals ?? 2;
  const raw = normalizeRawValue(value);

  if (!raw) {
    return options.emptyFallback ?? '';
  }

  const normalizedUnit = normalizeUnit(unit);

  if (canShowLbsToKgConversion(raw, normalizedUnit)) {
    const kg = (Number(raw) / LBS_TO_KG_DIVISOR).toFixed(decimals);
    return `${raw} lbs (${kg} kg)`;
  }

  const displayUnit = normalizedUnit || (options.defaultUnit ?? '').trim().toLowerCase();
  return displayUnit ? `${raw} ${displayUnit}` : raw;
}
